export default __webpack_public_path__ + "static/media/rabbit_type_2_2.55303922.svg";